import { render, staticRenderFns } from "./PresetRename.vue?vue&type=template&id=0acfe10e&lang=pug&"
import script from "./PresetRename.vue?vue&type=script&lang=ts&"
export * from "./PresetRename.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PresetRename.vue"
export default component.exports